<template>
    <div
        v-if="lang"
        class="alert-bg alert"
        :class="alertType"
        role="alert"
        v-show="show"
        @click="hideNow"
    >
        <close-modal @click="hideNow" />
        <div class="alert-flash">
            <div class="flash-content">
                <img class="icon" :src="'/img/icons/' + network + '/' + icon +  (this.$root.is_mobile ? '-mobile' : '-desktop') + '.svg'" height="250" width="250" />
                <strong>{{ exclamation }}</strong>
                <p v-html="body"></p>
            </div>
        </div>
    </div>
</template>

<script>
import CloseModal from './CloseModal'

export default {
    components: {
        'close-modal': CloseModal
    },

    props: {
        message: {
            type: String,
            required: false,
        },

        network: {
            type: String,
            default: 'tecnocasa',
        },

        timeoutSeconds: {
            type: Number,
            default: 4,
        },

        type: {
            type: String,
            default: 'success'
        },
    },

    data() {
        return {
            body: '',
            currentTimeoutSeconds: this.timeoutSeconds,
            currentType: this.type,
            show: false
        }
    },

    created() {
        if(this.message) {
            this.flash(this.message)
        }

        window.events.$on('flash', (message, type, seconds) => {
            this.currentType = type ? type : this.type

            this.currentTimeoutSeconds = seconds ? seconds : this.timeoutSeconds

            this.flash(message)
        })
    },

    computed: {
        alertType() {
            return 'is-' + (this.currentType ? this.currentType : 'success')
        },

        exclamation() {
            return this.currentType === 'success' ? this.lang.modal_title.success : this.lang.modal_title.error
        },

        icon() {
            return this.currentType === 'success' ? 'success' : 'error'
        },

        lang() {
            return this.$root.lang.words
        },
    },

    methods: {
        flash(message) {
            this.body = message
            this.show = true
            this.hide()
        },

        hide() {
            clearTimeout(timeout)

            let timeout = setTimeout(() => {
                this.show = false
            }, this.currentTimeoutSeconds * 2000)
        },

        hideNow() {
            this.show = false
        },
    },
}
</script>
